// extracted by mini-css-extract-plugin
export default {"title":"zVQuDVOn","description":"oBTDMttl","phone-input":"oxGckdI6","legal-text":"JImpeGEE"};